export function isNotSent(status) {
    return (
        status === 'pending' ||
        status === 'retry' ||
        status === 'waiting' ||
        status === 'queued'
    );
}

export function isError(status) {
    return (
        status === 'failure' ||
        status === 'timeout' ||
        status === 'cancel'
    );
}

export function isNotDone(status) {
    return (
        isNotSent(status) ||
        status === 'sent' ||
        status === 'ongoing'
    );
}
